import Component from 'components/pages/Deals/Deals.qmee';
import { buildPage, buildStaticProps } from 'utils/pageHelper';

export const getServerSideProps = buildStaticProps('deals');
export default buildPage(Component, {
  skipSSR: true,
  requiresAuthentication: false,
  metaData: {
    title: 'Deals',
    description:
      'Find deals and money saving coupons on the biggest brands around or just let us show you ones you’ll like.',
  },
});
